import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { ILectioPlugin } from './Types';

export class PluginLectioPlaceholderHtml implements ILectioPlugin {
	Init(): void {
		CKEDITOR.plugins.add('lectioPlaceholderHtml', {
			hidpi: true,

			init: editorOuter => {
				const config = LCDocumentEditorUtils.GetEditorConfig(editorOuter);
				if (!config.templateHtml)
					return;

				editorOuter.on('instanceReady', ei => {
					checkForContent(ei.editor, config.templateHtml);
				});
			}
		});
	}
}

/**
 * Laver foerste tekst-node i hvert element om til en attribut, som vi viser med css.
 * Paa den maade er der ike problemer med at indholdet skifter/rykker, naar man saetter fokus.
 */
function transformTemplateHtml(templateHtml: string): string {
	const fragment = CKEDITOR.htmlParser.fragment.fromHtml(templateHtml);
	fragment.forEach(ele => {
		const tn = ele.children.length !== 0 ? ele.children[0] : null;
		if (!(tn instanceof CKEDITOR.htmlParser.text))
			return;
		const isEmpty = /^\s*$/.test(tn.value);
		if (!isEmpty)
		{
			ele.attributes['data-lc-display-placeholder-text'] = tn.value;
			tn.remove();
		}
	}, 1);
	const writer = new CKEDITOR.htmlParser.basicWriter();
	fragment.writeHtml(writer);
	const transformedTemplateHtml = writer.getHtml(true);

	return transformedTemplateHtml;
}

function checkForContent(editor: CKEDITOR.editor, templateHtml: string): void {
	const $outerContainer = $('.cke_contents', editor.container.$);
	const data = editor.getData();
	if (data)
		return;

	const transformedTemplateHtml = transformTemplateHtml(templateHtml);
	editor.setData(transformedTemplateHtml, {
		noSnapshot: true
	});
	editor.resetDirtyLectio();
	$outerContainer.addClass('lc-placeholder');

	editor.restoreTemplate = true;

	let hasChanged = false;
	editor.once('change', () => {
		hasChanged = true;
		editor.restoreTemplate = false;
	});
	editor.on('focus', () => {
		$outerContainer.removeClass('lc-placeholder');

		editor.once('blur', () => {
			if (hasChanged)
				return;
			if (editor.restoreTemplate) {
				$outerContainer.addClass('lc-placeholder');
				editor.setData(transformedTemplateHtml, {
					noSnapshot: true
				});
			} else {
				editor.restoreTemplate = false;
			}
		});
	});
}
